import React from 'react'

const UserUtterance = ({ message, chatHistoryId }) => {
  return (
    <div className="chat-message received">
      <div className="message-content-send" data-chat-history-id={chatHistoryId}>
        <div className="user-message"><span>{message}</span></div>
      </div>
    </div>
  )
}

export default UserUtterance